import { history } from 'app/history';
import { doSelectCell, selectSelectedCell } from 'app/store';
import { parseSelectedCell } from './routes.js';

export const initializeHashParser = (store) => {
    const parseLocation = (location) => {
        const hashCell = parseSelectedCell(location);
        const selectedCell = selectSelectedCell(store.getState());

        if (
            hashCell?.rowIndex !== selectedCell?.rowIndex ||
            hashCell?.columnIndex !== selectedCell?.columnIndex
        ) {
            store.dispatch(doSelectCell(hashCell));
        }
    };

    parseLocation(history.location);

    history.listen(parseLocation);
};
